import React from "react";
import Dialog from "material-ui/Dialog";
import FlatButton from "material-ui/FlatButton";
import RaisedButton from "material-ui/RaisedButton";
import {RadioButton, RadioButtonGroup} from "material-ui/RadioButton";
import AddIcon from "material-ui/svg-icons/content/add";
import PropTypes from "prop-types";
import firebase from "firebase";
import TextField from "material-ui/TextField";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.bubble.css";
import "./NoticeWriteDialog.css";

export default class NoticeListWriteDialog extends React.Component {
    state = {
        open: false,
        title:'',
        msg:'',
        isPublic:1,
        created:firebase.database.ServerValue.TIMESTAMP,
        updated:firebase.database.ServerValue.TIMESTAMP
    };

    init(){
        this.setState({title:'', msg:'', isPublic:1});
    }

    handleOpen = () => {
        this.init();
        this.setState({open: true});
    };

    handleClose = () => {
        this.setState({open: false});
    };

    generateBtn(){
        return (<div style={{textAlign:'center', paddingTop:'2.5rem'}}>
            <RaisedButton
                style={{margin:'auto'}}
                label="공지사항 쓰기"
                onTouchTap={this.handleOpen}
                icon={<AddIcon className="muidocs-icon-content-add" />}
            />
        </div>);
    }

    submitHandler(){
        this.props.onSubmit({
            title:this.state.title,
            msg:this.state.msg,
            isPublic:this.state.isPublic,
            created:this.state.created,
            updated:this.state.updated,
            displayName:firebase.auth().currentUser.displayName,
            photoURL:firebase.auth().currentUser.photoURL,
            userKey:firebase.auth().currentUser.uid
        });
        this.setState({open:false});
    }

    generateDialog(){
        const actions = [
            <FlatButton
                label="저장"
                primary={true}
                keyboardFocused={true}
                onTouchTap={this.submitHandler.bind(this)}
            />,
            <FlatButton
                label="취소"
                primary={true}
                onTouchTap={this.handleClose}
            />
        ];
        return (
            <Dialog
                className="NoticeWriteDialog"
                actions={actions}
                modal={false}
                open={this.state.open}
                onRequestClose={this.handleClose}
                autoScrollBodyContent={true}
            >
                <TextField
                    value={this.state.title}
                    onChange={function(e){
                        this.setState({title:e.target.value});
                    }.bind(this)} fullWidth hintText="제목"
                /><br />

                <ReactQuill
                    value={this.state.msg}
                    theme="bubble"
                    onChange={function(value){
                        this.setState({msg:value});
                    }.bind(this)} /><br />

                <RadioButtonGroup
                    style={{display:'none'}}
                    name="isPublic"
                    defaultSelected={this.state.isPublic}
                    onChange={function(e){
                        this.setState({isPublic:Number(e.target.value)})
                    }.bind(this)}
                >
                    <RadioButton
                        value={1}
                        label="공개"
                    />
                    <RadioButton
                        value={0}
                        label="비공개"
                    />
                </RadioButtonGroup>
            </Dialog>
        );
    }

    render() {
        let dialog = null;
        if(this.state.open === true){
            dialog = this.generateDialog.bind(this)();
        }
        return (
            <div>
                {this.generateBtn()}
                {dialog}
            </div>
        );
    }
}

NoticeListWriteDialog.propTypes = {
    campaignId:PropTypes.number.isRequired,
    onSubmit:PropTypes.func.isRequired
}


// WEBPACK FOOTER //
// ./src/container/campaign/component/NoticeWriteDialog.js